import { useState, useEffect } from 'react';
import { activityAPI } from '../services/api';
import '../assets/css/user-activity.css';

const UserActivity = () => {
  const [activities, setActivities] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState('all');

  useEffect(() => {
    fetchActivity();
  }, []);

  const fetchActivity = async () => {
    try {
      setLoading(true);
      const response = await activityAPI.getUserActivity();
      if (response?.data) {
        setActivities(Array.isArray(response.data) ? response.data : response.data.activities || []);
      }
    } catch (error) {
    } finally {
      setLoading(false);
    }
  };

  const getActivityIcon = (type) => {
    const icons = {
      order: { icon: 'fa-box', color: '#3B82F6' },
      product: { icon: 'fa-shopping-bag', color: '#8B5CF6' },
      payment: { icon: 'fa-credit-card', color: '#10B981' },
      message: { icon: 'fa-comment', color: '#F59E0B' },
      review: { icon: 'fa-star', color: '#F59E0B' },
      login: { icon: 'fa-sign-in-alt', color: '#6B7280' },
      profile: { icon: 'fa-user', color: '#EF4444' },
      wallet: { icon: 'fa-wallet', color: '#22C55E' },
      wishlist: { icon: 'fa-heart', color: '#EC4899' },
      cart: { icon: 'fa-shopping-cart', color: '#06B6D4' },
    };
    return icons[type] || { icon: 'fa-clipboard', color: '#9CA3AF' };
  };

  const formatTime = (timestamp) => {
    const date = new Date(timestamp);
    const now = new Date();
    const diff = Math.floor((now - date) / 1000);

    if (diff < 60) return 'Just now';
    if (diff < 3600) return `${Math.floor(diff / 60)}m ago`;
    if (diff < 86400) return `${Math.floor(diff / 3600)}h ago`;
    if (diff < 604800) return `${Math.floor(diff / 86400)}d ago`;
    return date.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric' });
  };

  const getFilteredActivities = () => {
    if (filter === 'all') return activities;
    return activities.filter(activity => activity.type === filter);
  };

  const activityTypes = [
    { value: 'all', label: 'All Activity', icon: 'fa-list' },
    { value: 'order', label: 'Orders', icon: 'fa-box' },
    { value: 'payment', label: 'Payments', icon: 'fa-credit-card' },
    { value: 'message', label: 'Messages', icon: 'fa-comment' },
    { value: 'review', label: 'Reviews', icon: 'fa-star' },
  ];

  if (loading) {
    return (
      <div className="activity-container">
        <div className="activity-loading">
          <i className="fas fa-spinner fa-spin"></i>
          <p>Loading activity...</p>
        </div>
      </div>
    );
  }

  const filteredActivities = getFilteredActivities();

  return (
    <div className="activity-container">
      <div className="activity-header">
        <div className="activity-header-left">
          <h2>
            <i className="fas fa-history"></i> Recent Activity
          </h2>
          <p className="activity-subtitle">{activities.length} total activities</p>
        </div>
        <button onClick={fetchActivity} className="activity-refresh-btn" title="Refresh">
          <i className="fas fa-sync-alt"></i>
        </button>
      </div>

      {/* Filter Pills */}
      <div className="activity-filters">
        {activityTypes.map((type) => (
          <button
            key={type.value}
            className={`activity-filter-pill ${filter === type.value ? 'active' : ''}`}
            onClick={() => setFilter(type.value)}
          >
            <i className={`fas ${type.icon}`}></i>
            {type.label}
          </button>
        ))}
      </div>

      {filteredActivities.length === 0 ? (
        <div className="activity-empty">
          <i className="fas fa-inbox"></i>
          <p>No {filter !== 'all' ? filter : ''} activity found</p>
          <small>Your recent actions will appear here</small>
        </div>
      ) : (
        <div className="activity-list">
          {filteredActivities.map((activity, index) => {
            const iconData = getActivityIcon(activity.type);
            return (
              <div key={activity._id || activity.id || index} className="activity-item">
                <div className="activity-icon" style={{ backgroundColor: `${iconData.color}15`, border: `2px solid ${iconData.color}` }}>
                  <i className={`fas ${iconData.icon}`} style={{ color: iconData.color }}></i>
                </div>
                <div className="activity-content">
                  <p className="activity-text">{activity.description || activity.message}</p>
                  <div className="activity-meta">
                    <span className="activity-time">
                      <i className="far fa-clock"></i> {formatTime(activity.created_at || activity.timestamp)}
                    </span>
                    {activity.type && (
                      <span className="activity-type-badge" style={{ backgroundColor: `${iconData.color}15`, color: iconData.color }}>
                        {activity.type}
                      </span>
                    )}
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default UserActivity;
